export const numberOfSkeletonItems = 2
export const bottomGutterHeight = 24
export const dateHeaderHeight = 24
export const eventCardHeight = 112
export const gutterBetweenTwoEvents = 24